import React from 'react'

function ApprovedMaterialReport() {
  return (
    <div>ApprovedMaterialReport</div>
  )
}

export default ApprovedMaterialReport